export const PROMO_TC_ID = 'applepaypromo';
